import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { TServiceResult } from '@shared/helper/t-service-result';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { Injectable, inject } from "@angular/core";
import { BannerModel } from '@shared/model/banner-model';
import { TransferState } from '@angular/core';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';


@Injectable({
    providedIn: 'root'
})

export class BannerService extends HttpBaseService {
    private stateServer = inject(TransferState);

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'Banner')
    }

    getBanners(termFilter: TermFilterModel): Observable<TServiceResult<PageList<BannerModel>>> {
        const paramsValues = this.TermFilterParams(termFilter)

        return this.http.get<TServiceResult<PageList<BannerModel>>>(`${this.fileUrl}/GetBannersV2/${paramsValues}`)
        // .pipe(
        //     switchMap(banners => {
        //         this.stateServer.set<TServiceResult<PageList<BannerModel>>>(STATE_KEY_LAST_WEEK_BANNERS, banners)
        //         return of(banners)
        //     })
        // )
    }
}